import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';
import Icon from './Icon.jsx';

// The demo watermark.
//
// A slim, permanent bar on every page of the fictional demo client. It is NOT
// dismissible on purpose: its whole job is to make sure a screenshot taken during
// a pitch can never be mistaken for a real client's numbers, and a bar you can
// close is a bar that is closed in every screenshot.
//
// Server-side it is one call to /api/my/demo/:entityId (server/demoMode.js), which
// answers from the super-admin-only demo marker — not from anything the client can
// set. A real client never renders this because the endpoint says so, and the
// `demo` feature flag gates the route on top of that.
//
// Mobile-first: one line, wraps to two on a narrow phone, no fixed widths.
export default function DemoBanner({ entityId }) {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let alive = true;
    if (!entityId) { setInfo(null); return undefined; }
    api.myDemo(entityId)
      .then((r) => { if (alive) setInfo(r && r.demo ? r : null); })
      .catch(() => { /* best-effort: the flag gate 403s for every real client */ });
    return () => { alive = false; };
  }, [entityId]);

  if (!info) return null;

  return (
    <div
      role="note"
      style={{
        display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8,
        padding: '8px 14px', minHeight: 40, lineHeight: 1.35,
        background: 'linear-gradient(90deg, #7c3aed, #b4703a)', color: '#fff',
        fontSize: 13, fontWeight: 600,
      }}
    >
      <Icon name="beta" size={16} title="Demo account" />
      <strong>{info.label || 'Demo'}</strong>
      <span style={{ fontWeight: 400, opacity: 0.95 }}>{info.notice}</span>
    </div>
  );
}
